import { getRatingColor, type RatingColorT } from './ratingColor';

const STAR_PATH =
  'M12 .587l3.668 7.431 8.207 1.192-5.938 5.79 1.4 8.158L12 18.896l-7.337 3.862 1.4-8.158L.125 9.21l8.207-1.192z';

type RatingStarIconProps = {
  color: RatingColorT;
  size?: number;
};

/**
 * One star, painted in a single colour.
 *
 * It has no partial state and emits no `clipPath`. A fractional rating is drawn
 * by {@link RatingStars} clipping a whole ROW of these, which is the only way
 * the fraction can be continuous — a per-star clip can express halves and
 * nothing between them. It is also the only way the markup stays valid at
 * scale: an id declared inside this component is re-emitted once per star, so a
 * page with two fractional ratings carries duplicate DOM ids, and `url(#…)`
 * resolves document-wide to the first match regardless of which star asked.
 */
export function RatingStarIcon({ color, size = 16 }: RatingStarIconProps) {
  return (
    <svg
      className="shrink-0"
      height={size}
      width={size}
      viewBox="0 0 24 24"
      data-slot="rating-star-icon"
    >
      <path d={STAR_PATH} fill={getRatingColor(color)} />
    </svg>
  );
}
